/**
 * Customer Birthday Handler
 * 
 * Captures birthday data from registration forms and stores it in customer notes.
 * The birthday is stored in customer.note as a structured JSON field.
 * 
 * Note: Shopify's create_customer form doesn't directly support metafields,
 * so we use the note field as a temporary storage solution. 
 * You can later migrate this to proper customer metafields via Shopify Flow or apps.
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Find all customer registration forms
    const registerForms = document.querySelectorAll('form[action*="account"][action*="customer"]');
    
    registerForms.forEach(form => {
      // Check if form has birthday field
      const birthdayInput = form.querySelector('input[name="customer[note][birthday]"]');
      
      if (birthdayInput) {
        form.addEventListener('submit', handleFormSubmit);
      }
    });
  }

  function handleFormSubmit(e) {
    const form = e.target;
    const birthdayInput = form.querySelector('input[name="customer[note][birthday]"]');
    
    if (!birthdayInput || !birthdayInput.value) {
      return; // No birthday entered, proceed normally
    }

    // Format birthday data as JSON for storage in note field
    const birthdayData = {
      birthday: birthdayInput.value,
      timestamp: new Date().toISOString()
    };

    // Create a hidden input with the full note data
    let noteInput = form.querySelector('input[name="customer[note]"]');
    if (!noteInput) {
      noteInput = document.createElement('input');
      noteInput.type = 'hidden';
      noteInput.name = 'customer[note]';
      form.appendChild(noteInput);
    }

    // Store as JSON string in note field
    noteInput.value = JSON.stringify(birthdayData);

    // Remove the nested birthday field to avoid conflicts
    birthdayInput.remove();
  }

})();
